export default {
    name: 'subsidiaries',
    component: () => import(/* webpackChunkName: "subsidiaries-layout" */ '@/modules/subsidiaries/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.subsidiaries.index',
            component: () => import(/* webpackChunkName: "subsidiaries-index" */ '@/modules/subsidiaries/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.subsidiaries.create',
            component: () => import(/* webpackChunkName: "subsidiaries-create" */ '@/modules/subsidiaries/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.subsidiaries.edit',
            component: () => import(/* webpackChunkName: "subsidiaries-edit" */ '@/modules/subsidiaries/views/Edit'),
        },
    ]
}